export const AppConstant = {
    AUTH_DETAILS: 'AUTH_DETAILS',
    MSISDN: 'MSISDN',
    // Trigger Event Constants
    EVENT_NAME: 'eventName',
    INPUT_PARAMS: 'inputParams',
    CALLBACK: 'callback',

    // Get Header
    GET_HEADERS_METHOD: 'method',
    GET_HEADERS_URL: 'url',
    GET_HEADERS_PARAMS: 'params',
    GET_HEADERS_EVENT: 'getHeaders',
    GET_HEADERS_CALLBACK: 'onGetHeaderSuccess',

    // Close
    CLOSE_EVENT: 'close',
};

export const regex = {
    DATE_TIME: /\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d(?:\.\d+)?Z?/
}


export const LoginAuthConstants = {
    WEB_TOKEN_SHORTLIVED: "WEB_TOKEN_SHORTLIVED",
  };
  
  export const OS_TYPE = "WEB";
  
  export const LOGIN_CONSTANTS = {
    staticToken: "static-token",
    dynamicToken: "dynamic-token",
    uid: "uid",
    loggedInUser: "aa-auk",
    pathName: "pathName",
    accessToken: "access-token",
    refreshToken: "refresh-token",
  };
  
  export const CONSUMER_NAME_HEADER = "AirtelIn";

export const URL_CONSTANT = {
  SMS_HEADER_INFO: "https://www.airtel.in/business/commercial-communication/sms-header-info"
};